<template>
  <div :class="['login',(platformName&&(platformName==='luobei'))?'login2':'']">
    <a-form @submit.prevent="doLogin"
            :form="form">
      <a-alert type="error"
               :closable="true"
               v-show="error"
               :message="error"
               showIcon
               style="margin-bottom: 24px;"></a-alert>

      <a-form-item label="用户名">
        <a-input placeholder="请输入用户名"
                 size="large"
                 v-decorator="['name', { rules: [{ required: true, message: '请输入用户名', whitespace: true }] }]">
          <!-- <a-icon slot="prefix" type="user"></a-icon> -->
        </a-input>
      </a-form-item>
      <a-form-item label="密码">
        <a-input placeholder="输入密码"
                 size="large"
                 type="password"
                 v-decorator="['password', { rules: [{ required: true, message: '请输入密码', whitespace: true }] }]">
          <!-- <a-icon slot="prefix" type="lock"></a-icon> -->
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-button :loading="loading"
                  class="u-btn-success"
                  size="large"
                  htmlType="submit"
                  type="primary">登录</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { Encrypt } from '../../utils/Secret.js'
import platformName from '@/utils/platform'
export default {
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  data () {
    return {
      loading: false,
      error: '',
      platform: '', // 平台id
      platformName: platformName,
      platformType: '' // 默认是萝北确权系统 true 则是萝北县惠农补贴数据认证系统

    }
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  created () {
    this.$db.clear()
    this.$router.options.routes = []
  },
  mounted () {
    // 获取路由传参
    if (this.platformName === 'luobei') {
      // 处理萝北登录
      let searchUrl = decodeURI(window.location.href).split('?')
      // if (searchUrl.split('?').length <= 1) return
      // let param = searchUrl.split('?')[1].split('=')[1]
      // if (param === 'luobei') this.platformType = param
      if (searchUrl[0].indexOf('luobei') !== -1) {
        this.platformType = 'luobei'
      }
    }

    if (window.location.href && (this.platformName !== 'luobei')) {
      let searchUrl = decodeURI(window.location.href)
      // let params = searchUrl.replace('?params=', '')
      // 无查询参数不继续执行
      if (searchUrl.split('?').length <= 1) return
      let params = searchUrl.split('?')[1].replace('params=', '')
      // let params = window.location.search.replace("?params=", "");
      let passParams = JSON.parse(decodeURIComponent(params))
      if (passParams.platform && passParams.platform.toString()) {
        this.form.setFieldsValue({ 'name': passParams.username, 'password': passParams.pwd })

        // this.form.setFieldValue('password', passParams.pwd)
        this.platform = passParams.platform.toString()
      }
    }
  },

  methods: {
    doLogin () {
      // // 测试跳转
      // let params = {platform: 1}
      // let urls = 'http://192.168.50.112:8086/#/login_suihua' + '?params=' + JSON.stringify(params)
      // 		urls = encodeURI(urls)
      // let newWindow = window.open('_blank')
      // newWindow.location = urls
      // return

      // 用户名密码登录
      this.form.validateFields(['name', 'password'], (errors, values) => {
        if (!errors) {
          this.loading = true
          let name = this.form.getFieldValue('name')
          let password = this.form.getFieldValue('password')
          this.$post('login', {
            username: name,
            // password: password,
            password: Encrypt(password) // 密码加密
          })
            .then(r => {
              let data = r.data.data
              // 统一返回的地址数据类型
              data.userArea.province = (data.userArea.province ? parseInt(data.userArea.province) : '')
              data.userArea.city = (data.userArea.city ? parseInt(data.userArea.city) : '')
              data.userArea.county = (data.userArea.county ? parseInt(data.userArea.county) : '')
              data.userArea.country = (data.userArea.country ? parseInt(data.userArea.country) : '')
              data.userArea.village = (data.userArea.village ? parseInt(data.userArea.village) : '')
              localStorage['btname'] = data.userArea.province_name + '/' + data.userArea.city_name + '/' + data.userArea.county_name
              localStorage['province_name'] = data.userArea.province_name
              localStorage['city_name'] = data.userArea.city_name
              localStorage['county_name'] = data.userArea.county_name
              localStorage['userArea'] = data.userArea.county
              localStorage['country_name'] = data.userArea.country_name
              localStorage['country_code'] = data.userArea.country

              this.saveLoginData(data)
              setTimeout(() => {
                this.loading = false
              }, 500)
              // this.$router.push('/ledger');
              // this.$router.push('/')

              if (this.platform === '1') {
                // 农业保险管理系统
                this.$router.push('/insurance/insuranceClaims/TjInsuranceClaims')
              } else if (this.platform === '2') {
                // 惠农补贴公示系统
                this.$router.push('/workAllowance/county')
              } else if (this.platform === '3') {
                // 生产者补贴管理系统
                // this.$router.push('/')
                this.$router.push('/themePage/subsidyTheme')
              } else if (this.platformName === 'luobei') {
                // 萝北县登录后进台账

                this.$router.push('/themePage/plant')
              }

              // else if (this.platform === '4') {
              //   // 萝北县农村土地确权综合应用平台
              //   this.$router.push('/themePage/subsidyTheme')
              // } else if (this.platform === '5') {
              //   // 萝北县惠农补贴数据认证系统
              //   this.$router.push('/themePage/subsidyTheme')
              // }

              else {
                this.$router.push('/')
              }
            })
            .catch(e => {
              // console.error(e);
              setTimeout(() => {
                this.loading = false
              }, 500)
            })
        }
      })
    },

    ...mapMutations({
      setToken: 'account/setToken',
      setExpireTime: 'account/setExpireTime',
      setPermissions: 'account/setPermissions',
      setRoles: 'account/setRoles',
      setUser: 'account/setUser',
      setUserArea: 'account/setUserArea',
      setTheme: 'setting/setTheme',
      setLayout: 'setting/setLayout',
      setMultipage: 'setting/setMultipage',
      fixSiderbar: 'setting/fixSiderbar',
      fixHeader: 'setting/fixHeader',
      setColor: 'setting/setColor',
      setPlatform: 'setting/setPlatform'
    }),
    saveLoginData (data) {
      this.setToken(data.token)
      this.setExpireTime(data.exipreTime)
      this.setUser(data.user)
      this.setUserArea(data.userArea)
      this.setPermissions(data.permissions)
      this.setRoles(data.roles)
      this.setTheme(data.config.theme)
      this.setLayout(data.config.layout)
      this.setMultipage(data.config.multiPage === '1')
      this.fixSiderbar(data.config.fixSiderbar === '1')
      this.fixHeader(data.config.fixHeader === '1')
      this.setColor(data.config.color)

      this.setPlatform(this.platformType)
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  .icon {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.2);
    margin-left: 16px;
    vertical-align: middle;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #1890ff;
    }
  }
  .u-btn-success {
    width: 100%;
    margin-top: 4px;
    background: #183fa9;
    border-color: #183fa9;
    height: 44px;
    line-height: 44px;
    font-size: 16px !important;
    &:hover {
      background: #183fa9;
    }
  }
}
.login2 {
  .u-btn-success {
    width: 100%;
    margin-top: 4px;
    background: #23aa85;
    border-color: #23aa85;
    height: 44px;
    line-height: 44px;
    font-size: 16px !important;
    &:hover {
      background: #23aa85;
    }
  }
  /deep/ .ant-form-item-label label {
    font-size: 16px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/loginLuobei/Login.vue